module.exports = __webpack_public_path__ + "img/fm-f-Path 51@3x.c1b076a9.png";